/** The customer guides, as a catalogue - what exists, for whom, and its state.
 *
 * Source: `docs/customer/00-customer-documentation-status.md`, which is the one place that says
 * what each guide is and whether it may be sent. **Every guide there is a draft, and none is
 * approved copy** (counsel's engagement is scheduled after the product is built, B-02), so this
 * catalogue lists them as drafts and publishes none of their text: the guides state no legal
 * position and some pages here would have to. A guide moves from `draft` to released here only
 * when a person has decided that file may be sent - `guidesContent.test.ts` fails if the list and
 * that status file disagree about which guides exist.
 *
 * Titles and audiences only: no sentence of a guide is copied, because a second copy of a guide is
 * the one that goes stale when the first is re-checked against the code.
 */

export type GuideState = "draft";

export interface Guide {
  /** The guide's number in `docs/customer`, which is how it is named when someone asks for it. */
  id: string;
  title: string;
  audience: string;
  state: GuideState;
}

export const GUIDES: readonly Guide[] = [
  { id: "01", title: "Onboarding", audience: "A company's administrator", state: "draft" },
  { id: "02", title: "User guide", audience: "Contributors, Approvers, Auditors and Viewers", state: "draft" },
  { id: "06", title: "Admin guide", audience: "A company's Admin", state: "draft" },
  { id: "07", title: "Methodology: how a figure is made", audience: "Reporting lead, methodologist, assurance provider", state: "draft" },
  { id: "08", title: "Inventory template", audience: "Whoever loads readings from a spreadsheet", state: "draft" },
  { id: "09", title: "Closing and reopening a period", audience: "Approver, Admin", state: "draft" },
  { id: "10", title: "Notifications", audience: "Everyone", state: "draft" },
  { id: "11", title: "Supplier collection", audience: "Admin, Approver", state: "draft" },
  { id: "12", title: "Factor library", audience: "Methodologist, Approver, Admin", state: "draft" },
  { id: "13", title: "Ledger and audit export", audience: "Admin, Approver, Auditor, assurance provider", state: "draft" },
  { id: "14", title: "Auditor access", audience: "Admin, Auditor, assurance provider", state: "draft" },
  { id: "03", title: "Changes and versions", audience: "Administrator, methodologist, assurance provider", state: "draft" },
  { id: "04", title: "Data lifecycle", audience: "Administrator, procurement, data protection", state: "draft" },
  { id: "05", title: "Accessibility statement", audience: "Anyone", state: "draft" },
  { id: "15", title: "UK SECR (phase 2)", audience: "A UK company", state: "draft" },
];
